export const SNACKBAR = '[Snackbar]';

export const SET_SNACKBAR = `${SNACKBAR} SET_SNACKBAR`;
